import { render, staticRenderFns } from "./NaviBar.vue?vue&type=template&id=160b8460&scoped=true&"
import script from "./NaviBar.vue?vue&type=script&lang=js&"
export * from "./NaviBar.vue?vue&type=script&lang=js&"
import style0 from "./NaviBar.vue?vue&type=style&index=0&id=160b8460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160b8460",
  null
  
)

export default component.exports